import React from 'react';
import ReactDOM from 'react-dom';
import { init } from '@fluentsms/i18n';
import App from './App';

function renderApp() {
  ReactDOM.render(<App />, document.getElementById('root'));
}

/**
 * i18n must be initialized before any yup schema for yup integration to succeed
 * making App loadable after i18n.init the yup locale is defined before any schema defined
 */
init();

renderApp();
